// Copyright 2017 Sorama B.V.

export interface IFilter<TFilterType> {
    filter(items: TFilterType[]): Promise<TFilterType[]>;
}

export class DelegateFilter<TFilterType> implements IFilter<TFilterType> {
    private delegate: (item: TFilterType) => Promise<boolean>;

    constructor(delegate: (item: TFilterType) => Promise<boolean>) {
        this.delegate = delegate;
    }

    public filter(items: TFilterType[]): Promise<TFilterType[]> {
        const filteredItems = <TFilterType[]>[];
        const promises = <Promise<void>[]>[];

        for (const item of items) {
            promises.push(
                this.delegate(item).then((x) => {
                    if (x) {
                        filteredItems.push(item);
                    }
                })
            );
        }

        return Promise.all(promises).then(() => filteredItems);
    }
}
